module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "font-weight-bold darkgrey--text",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$attrs.detail.sub_interpretation_id || _vm.$attrs.detail.cta_id ?
    "Ubah" :
    "Tambah") + "\n\n            Sub Interpretasi\n\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDeleteItem()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-delete")]), _vm._v("\n                Hapus\n            ")], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-5"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                        Jenis Sub Interpretasi\n                    ")]), _vm._v(" "), _c('div', [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "row": "",
      "disabled": _vm.$attrs.detail.sub_interpretation_id ||
        _vm.$attrs.detail.cta_id
    },
    model: {
      value: (_vm.content_type),
      callback: function($$v) {
        _vm.content_type = $$v
      },
      expression: "content_type"
    }
  }, [_c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Text",
      "value": "text",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "CTA",
      "value": "cta",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.content_type === 'text') ? [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                            Judul\n                        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul",
      "outlined": ""
    },
    model: {
      value: (_vm.data.title),
      callback: function($$v) {
        _vm.$set(_vm.data, "title", $$v)
      },
      expression: "data.title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        _vm.data.image &&
        _vm.data.image != '' ?
        _vm.data.image :
        require('@/assets/img/unavailable.png')
    }
  })])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    staticClass: "font-weight-bold blew--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_vm._v("\n                                    Upload Foto\n                                ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "id": "photo_tema_skala",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3 grey--text",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("\n                                    Rasio thumbnail Icon 1:1 (HD)\n                                ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                            Deskripsi\n                        ")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('app-editor', {
    attrs: {
      "value": _vm.data.description,
      "hasUpload": false,
      "title": 'Deskripsi'
    },
    on: {
      "content-updated": function($event) {
        _vm.data.description = $event
      }
    }
  })], 1)] : [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                            Jenis CTA\n                        ")]), _vm._v(" "), _c('div', [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "row": "",
      "disabled": _vm.$attrs.detail.cta_id
    },
    on: {
      "change": function($event) {
        _vm.data_cta.cta_contents = []
      }
    },
    model: {
      value: (_vm.data_cta.cta_name),
      callback: function($$v) {
        _vm.$set(_vm.data_cta, "cta_name", $$v)
      },
      expression: "data_cta.cta_name"
    }
  }, [_c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Career Mapping",
      "value": "prodi",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Konsul",
      "value": "konsul",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Fitur",
      "value": "fitur",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.data_cta.cta_name === 'konsul') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                            Mata Pelajaran Konsul\n                        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "items": _vm.mapelList,
      "outlined": "",
      "item-text": "nama",
      "item-value": "id",
      "placeholder": "Pilih Mata Pelajaran"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex py-3",
          staticStyle: {
            "align-items": "center",
            "gap": "15px",
            "width": "100%"
          },
          on: {
            "click": function($event) {
              return _vm.addCTAContent(item, 'konsul')
            }
          }
        }, [_c('div', [_c('img', {
          attrs: {
            "src": item.picture,
            "width": "40",
            "height": "40"
          }
        })]), _vm._v(" "), _c('div', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("\n                                        " + _vm._s(item.nama) + "\n                                    ")])])]
      }
    }], null, false, 2689584039),
    model: {
      value: (_vm.mapel_konsul),
      callback: function($$v) {
        _vm.mapel_konsul = $$v
      },
      expression: "mapel_konsul"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data_cta.cta_name === 'fitur') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                            Fitur\n                        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "items": _vm.featureList,
      "outlined": "",
      "item-text": "nama",
      "item-value": "id",
      "placeholder": "Pilih Fitur"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex py-3",
          staticStyle: {
            "align-items": "center",
            "gap": "15px",
            "width": "100%"
          },
          on: {
            "click": function($event) {
              return _vm.addCTAContent(item, 'fitur')
            }
          }
        }, [_c('div', [_c('img', {
          attrs: {
            "src": item.picture,
            "width": "39",
            "height": "39"
          }
        })]), _vm._v(" "), _c('div', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("\n                                        " + _vm._s(item.nama) + "\n                                    ")])])]
      }
    }], null, false, 2549274875),
    model: {
      value: (_vm.feature),
      callback: function($$v) {
        _vm.feature = $$v
      },
      expression: "feature"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), [_c('v-row', _vm._l((_vm.data_cta.cta_contents), function(data, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-card', {
      staticClass: "mb-5",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-2"
    }, [_c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "align-items": "center",
        "gap": "10px"
      }
    }, [_c('div', [_c('v-img', {
      attrs: {
        "src": data.content_icon,
        "width": "39",
        "height": "39"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "darkgrey--text"
    }, [_vm._v("\n                                            " + _vm._s(data.content_name) + "\n                                        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-right": "8px",
        "position": "absolute",
        "right": "0"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeCTAContent(data)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("mdi-close")])], 1)], 1)])])], 1)], 1)
  }), 1)], _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                            Deskripsi\n                        ")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('app-editor', {
    attrs: {
      "value": _vm.data_cta.cta_description,
      "hasUpload": false,
      "title": 'Masukan Deskripsi'
    },
    on: {
      "content-updated": function($event) {
        _vm.data_cta.cta_description = $event
      }
    }
  })], 1)]], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                Tutup\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.content_type === 'cta' ? _vm.saveCta() : _vm.upload()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "490px"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "py-2"
  }, [_c('v-card-title', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                Apakah anda akan menghapus interpretasi ini ?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v(" interpretasi ini akan dihapus. ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoadingForm
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v("\n                    Ok\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ace3c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/DialogSubInterpretasi.vue
// module id = 1474
// module chunks = 1